import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { Link } from "react-router-dom";
import whobanner from "../img/cares.png";

const Careers = () => {
  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1200, once: true });

    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? (window.scrollY / totalHeight) * 100 : 0;
      setScrollProgress(progress);
      setShowScroll(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
<div className="min-h-screen font-sans bg-white overflow-x-hidden pt-20">

      <Helmet>
        <title>Careers – SecurXpert Technologies</title>
        <meta
          name="description"
          content="Our recruitment journey at SecurXpert Technologies is designed to find the right talent the right way – from profile screening and technical evaluations to HR discussions. Discover why you should choose SecurXpert: accelerated career growth, inclusive culture, work-life harmony and empowering innovation."
        />
      </Helmet>

   <div className="fixed top-0 left-0 right-0 z-[999]">
  <Navbar />
</div>


      {/* Hero Section */}
      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${whobanner})` }}
        >
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/70 lg:bg-black/60" />

          {/* Centered text content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
              Careers
            </h1>

            <div className="flex items-center gap-2 text-sm sm:text-base">
              <Link to="/" className="hover:underline">Home</Link>
              <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                className="mt-[2px]"
              >
                <path
                  d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                  fill="white"
                />
              </svg>
              <span>Careers</span>
            </div>
          </div>
        </div>
      </header>

      {/* Recruitment Journey Section */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
    {/* Left Content */}
    <div data-aos="fade-right" className="self-center">
      <h2 className="text-indigo-950 text-3xl font-bold font-['Roboto'] mb-6">
        Our Recruitment Journey <br/> Finding the Right Talent,The Right Way 
      </h2>
      <p className="text-zinc-600 text-base font-normal font-['Barlow'] leading-6">
        At SecurXpert Technologies, we follow a clear, thoughtful hiring process that helps talented professionals connect smoothly and confidently to the right roles.
      </p>
    </div>

          {/* Right Cards */}
       <div className="grid grid-cols-1 md:grid-cols-2 gap-6 auto-rows-fr">
  {/* CARD */}
  {[
    {
      title: "Profile Screening",
      desc: "Evaluating qualifications, role feasibility & career alignment.",
      delay: 100,
      // icon: (
      //   <svg width="30" height="31" viewBox="0 0 30 31" fill="none">
      //     <path
      //       d="M8.33333 6.68416C8.33333 4.91141..."
      //       fill="white"
      //     />
      //   </svg>
      // ),
    },
    {
      title: "Technical Assessments",
      desc: "Testing logic, domain expertise and coding proficiency.",
      delay: 200,
      // icon: (
      //   <svg width="40" height="30" viewBox="0 0 40 30" fill="none">
      //     <path d="M4 4.18634C4 1.87731..." fill="white" />
      //   </svg>
      // ),
    },
    {
      title: "Advanced Technical Evaluation",
      desc: "Assessing expertise at basic, advanced & expert levels.",
      delay: 300,
      // icon: (
      //   <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
      //     <path d="M27.5 2.5V27.5H2.5V2.5..." fill="white" />
      //   </svg>
      // ),
    },
    {
      title: "HR Discussion",
      desc: "Understanding expectations, culture fit, policies & benefits.",
      delay: 400,
      // icon: (
      //   <svg width="30" height="31" viewBox="0 0 30 31" fill="none">
      //     <path d="M14.7915 0.753042C15.5173..." fill="white" />
      //   </svg>
      // ),
    },
  ].map((item, index) => (
    <div
      key={index}
      data-aos="fade-up"
      data-aos-delay={item.delay}
      className="bg-indigo-950 rounded-[10px] p-6 text-center h-full flex flex-col items-center"
    >
      {/* ICON (fixed height) */}
      {/* <div className="flex items-center justify-center h-12 mb-4">
        {item.icon}
      </div> */}

      {/* TITLE */}
      <h3 className="text-white text-xl font-semibold font-['Roboto'] leading-8 mb-2">
        {item.title}
      </h3>

      {/* DESCRIPTION */}
      <p className="text-white text-base font-normal font-['Barlow'] leading-6">
        {item.desc}
      </p>
    </div>
  ))}
</div>

        </div>
      </div>

      {/* Why Choose SecurXpert Section */}
      <div className="relative w-full py-16 bg-indigo-950">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <h2 className="text-white text-4xl font-bold font-['Roboto'] mb-4">
              Why Choose SecurXpert?
            </h2>
            <p className="text-white text-base font-normal font-['Barlow'] leading-6">
              Your career journey starts here. Let&apos;s build the future together!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div
              className="bg-white rounded-[10px] p-6 flex items-center gap-4 border-l-4 border-indigo-500"
              data-aos="fade-up"
            >
              <img
                className="w-20 h-20 rounded-full"
                src="https://placehold.co/75x75/6366F1/FFFFFF?text=GROW"
                alt="Career Growth"
              />
              <div className="flex-1">
                <h3 className="text-indigo-950 text-xl font-semibold font-['Roboto'] leading-8 mb-2">
                  Accelerated Career Growth
                </h3>
                <p className="text-zinc-600 text-base font-normal font-['Barlow'] leading-6">
                  Opportunities that challenge, inspire and advance careers.
                </p>
              </div>
            </div>

            <div
              className="bg-white rounded-[10px] p-6 flex items-center gap-4 border-l-4 border-indigo-400"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <img
                className="w-20 h-20 rounded-full"
                src="https://placehold.co/75x75/818CF8/FFFFFF?text=TEAM"
                alt="Culture"
              />
              <div className="flex-1">
                <h3 className="text-indigo-950 text-xl font-semibold font-['Roboto'] leading-8 mb-2">
                  Inclusive &amp; Diverse Work Culture
                </h3>
                <p className="text-zinc-600 text-base font-normal font-['Barlow'] leading-6">
                  A collaborative ecosystem where ideas are valued.
                </p>
              </div>
            </div>

            <div
              className="bg-white rounded-[10px] p-6 flex items-center gap-4 border-l-4 border-blue-800"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <img
                className="w-20 h-20 rounded-full"
                src="https://placehold.co/75x75/1E3A8A/FFFFFF?text=BALANCE"
                alt="Work-Life"
              />
              <div className="flex-1">
                <h3 className="text-indigo-950 text-xl font-semibold font-['Roboto'] leading-8 mb-2">
                  Work-Life Harmony
                </h3>
                <p className="text-zinc-600 text-base font-normal font-['Barlow'] leading-6">
                  A healthy balance that supports both your career growth and your overall well-being.
                </p>
              </div>
            </div>

            <div
              className="bg-white rounded-[10px] p-6 flex items-center gap-4 border-l-4 border-blue-600"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <img
                className="w-20 h-20 rounded-full"
                src="https://placehold.co/75x75/2563EB/FFFFFF?text=INNOVATE"
                alt="Innovation"
              />
              <div className="flex-1">
                <h3 className="text-indigo-950 text-xl font-semibold font-['Roboto'] leading-8 mb-2">
                  Empowering Innovation
                </h3>
                <p className="text-zinc-600 text-base font-normal font-['Barlow'] leading-6">
                  A work environment where your strengths turn into meaningful outcomes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* Premium Scroll to Top Button with Progress Ring */}
      {showScroll && (
        <div
          onClick={scrollToTop}
          className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
        >
          <svg
            className="progress-circle -rotate-90 w-12 h-12 absolute"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - (307.919 * scrollProgress) / 100}
              style={{ transition: "stroke-dashoffset 0.1s linear" }}
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-white relative z-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default Careers;
